// Keep this module identical in both frontend apps (checked by supportContact.contract.test.js).
export const SUPPORT_EMAIL = 'wedlinx@catalinx.space';
export const SUPPORT_EMAIL_URL = `mailto:${SUPPORT_EMAIL}`;
export const SUPPORT_WHATSAPP_NUMBER = '+65 8527 7976';
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/6585277976';
export const SUPPORT_RESPONSE_TIME = 'We typically reply within 24 hours.';
